import { Injectable, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpService } from './http.service';
import { UiServices } from './ui-services';

@Injectable({
  providedIn: 'root',
})
export class PendingOrdersService {
  private _page = 1;
  get page() {
    return this._page;
  }

  set page(value) {
    this._page = value;
  }

  public reloadList = new EventEmitter();

  constructor(
    private httpSv: HttpService,
    private translateSv: TranslateService,
    private uiSv: UiServices
  ) {}

  async getOrders() {
    const param = { pag: this._page };
    const res = await this.httpSv.itemIndex('client/order', '', param);
    const data = res.data;
    return data;
  }

  async deleteOrder(orders) {
    try {
      const msg = this.translateSv.instant(
        'ESTAS_SEGURO_QUE_DESEAS_ELIMINAR_LA_ORDEN'
      );
      const { role } = await this.uiSv.presentAlert(msg);
      if (role === 'accept') {
        const id = orders.id;
        const body = { id };

        await this.uiSv.showLoading();
        const res = await this.httpSv.itemAction(
          body,
          'client/order',
          'destroy'
        );
        if (res.state) {
          const msg = this.translateSv.instant('ORDEN_ELIMINADA_CON_EXITO');
          await this.uiSv.showToast(msg);
          this.reloadList.emit();
        }
        await this.uiSv.loading.dismiss();
        return true;
      }
    } catch (err) {
      console.error(err);
      await this.uiSv.loading.dismiss();
    }
  }
}
